/**
 * Scroll Popup
 * Displays a popup after scrolling X pixels
 * Uses sessionStorage to prevent showing multiple times per session
 */

(function($) {
  'use strict';

  const ScrollPopup = {
    popup: null,
    overlay: null,
    closeBtn: null,
    scrollTrigger: 800,
    isShown: false,
    storageKey: 'processus_popup_shown',

    init: function() {
      this.popup = $('#scroll-popup');

      if (!this.popup.length) {
        return;
      }

      this.overlay = this.popup.find('.scroll-popup__overlay');
      this.closeBtn = this.popup.find('.scroll-popup__close');
      this.scrollTrigger = parseInt(this.popup.data('scroll-trigger')) || 800;

      // Check if popup has already been shown this session
      if (sessionStorage.getItem(this.storageKey)) {
        return;
      }

      this.bindEvents();
      this.checkScroll();
    },

    bindEvents: function() {
      const self = this;

      // Scroll event
      $(window).on('scroll.scrollpopup', function() {
        self.checkScroll();
      });

      // Close button click
      this.closeBtn.on('click', function(e) {
        e.preventDefault();
        self.closePopup();
      });

      // Overlay click
      this.overlay.on('click', function() {
        self.closePopup();
      });

      // ESC key
      $(document).on('keydown.scrollpopup', function(e) {
        if (e.key === 'Escape' && self.isShown) {
          self.closePopup();
        }
      });

      // Prevent body scroll when popup is open
      this.popup.on('transitionend', function() {
        if (self.popup.hasClass('is-visible')) {
          $('body').addClass('popup-open');
        }
      });
    },

    checkScroll: function() {
      if (this.isShown) {
        return;
      }

      const scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollY >= this.scrollTrigger) {
        this.showPopup();
      }
    },

    showPopup: function() {
      if (this.isShown) {
        return;
      }

      this.isShown = true;
      this.popup.addClass('is-visible');
      $('body').css('overflow', 'hidden');

      // Mark as shown in session storage
      sessionStorage.setItem(this.storageKey, 'true');

      // Unbind scroll event after showing
      $(window).off('scroll.scrollpopup');
    },

    closePopup: function() {
      const self = this;

      this.popup.addClass('is-closing');
      $('body').css('overflow', '');
      $('body').removeClass('popup-open');

      setTimeout(function() {
        self.popup.removeClass('is-visible is-closing');
      }, 400);
    }
  };

  // Initialize on document ready
  $(document).ready(function() {
    ScrollPopup.init();
  });

})(jQuery);
